module.exports = __webpack_public_path__ + "fc019a04e9be24b19fbbe4e5fc1e0920.svg";